// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"resources_title__1H2OV","input":"resources_input__3uuAl","filter-tags":"resources_filter-tags__2Hri8"};